import { currentAdapter } from './axiosClient'
import { AxiosResponse } from 'axios'
import { AuthProviderLoginUrlResponse, ForgetPasswordRequest, LoginRequest, LoginResponse, User, UserSignUpRequest, ValidateThirdPartyTokenRequest } from '../../proto/generated/identity'

export const getLoginUrl = async (args: { body: any }): Promise<AuthProviderLoginUrlResponse> => {
    return await currentAdapter.getLoginUrl(args.body)
}

export const LoginWithMail = async (args: { body: LoginRequest }): Promise<LoginResponse> => {
    return await currentAdapter.loginWithMail(args.body)
}

export const SignUpWithMail = async (args: { userSignUpRequest: UserSignUpRequest }): Promise<LoginResponse> => {
    return await currentAdapter.signUpWithMail(args.userSignUpRequest)
}

export const SendEmailOtp = async (args: { body: { email: string } }): Promise<AxiosResponse> => {
    return await currentAdapter.sendEmailOtp(args.body.email)
}

export const ForgetPassword = async (args: { body: ForgetPasswordRequest }): Promise<User> => {
    return await currentAdapter.forgetPassword(args.body)
}

export const validateToken = async (args: { body: ValidateThirdPartyTokenRequest }): Promise<LoginResponse> => {
    return await currentAdapter.validateToken(args.body)
}

export const logout = (): void => {
    currentAdapter.logout()
}
